import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { ZefFormsModule } from '@zerops/zef/forms';
import { FormSectionModule } from '@zerops/zui/form-section';
import { CodeFieldModule } from '@zerops/zui/code-field';
import { UserDataFormFieldModule } from '@zerops/zerops/common/user-data-form-field';
import { MaterialFormStackModule } from '@zerops/zerops/core/material-form-stack';
import { GithubRepoFormModule } from '@zerops/zerops/feature/github-repo-form';
import { GitlabRepoFormModule } from '@zerops/zerops/feature/gitlab-repo-form';
import { ZuiDocsTextModule } from '@zerops/zui/docs-text';
import { ZefPipesModule } from '@zerops/zef/pipes';
import { ZuiAutoscalingFormFieldModule } from '@zerops/zui/autoscaling-form-field';
import {
  NginxServiceStackFormComponent
} from './nginx-service-stack-form.component';
import {
  NginxServiceStackFormTranslationsModule
} from './nginx-service-stack-form.translations';
import { HostnameFieldModule } from '../../fields';
import { ZuiSeparatorComponent } from '@zerops/zui/separator';

@NgModule({
  declarations: [ NginxServiceStackFormComponent ],
  imports: [
    CommonModule,
    ZefFormsModule,
    MatButtonModule,
    MatIconModule,
    FormSectionModule,
    HostnameFieldModule,
    CodeFieldModule,
    NginxServiceStackFormTranslationsModule,
    UserDataFormFieldModule,
    MaterialFormStackModule,
    GithubRepoFormModule,
    GitlabRepoFormModule,
    ZuiDocsTextModule,
    ZefPipesModule,
    ZuiAutoscalingFormFieldModule,
    ZuiSeparatorComponent
  ],
  exports: [ NginxServiceStackFormComponent ]
})
export class NginxServiceStackFormModule {

}
